import { VerticalizedLandingPageShopType } from "@faire/web-api/indigofair/data/VerticalizedLandingPageShopType";
import { route as cafeAndRestaurantLandingPageRoute } from "@faire/web-api/routes/shop/cafe-and-restaurant";
import { route as spaAndSalonLandingPageRoute } from "@faire/web-api/routes/shop/salon-spa";
import { getCurrentPath } from "@faire/web/common/Path";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";

export const getVerticalizedLandingPageShopType = () => {
  if (
    pathMatchesRoute(getCurrentPath().pathname, spaAndSalonLandingPageRoute)
  ) {
    return VerticalizedLandingPageShopType.SPA_SALON;
  }

  if (
    pathMatchesRoute(
      getCurrentPath().pathname,
      cafeAndRestaurantLandingPageRoute
    )
  ) {
    return VerticalizedLandingPageShopType.CAFE_RESTAURANT;
  }

  return undefined;
};
